import { apiGet, apiPost } from '../utils/axios';

const base_url = `/certificate`;

export const getCertificate = (id) => {
  return apiGet(`${base_url}/${id}`);
};

export const createCertificate = (data) => {
  return apiPost(`${base_url}/create`, data);
};

export const getCertificates = () => {
  return apiGet(`${base_url}/all`);
};

export const createBLNextCertificate = (data) => {
  return apiPost(`${base_url}/create-bl`, data);
};
